import * as React from "react";
import Svg, { Path } from "react-native-svg";
const CityMallRedTextLogo = (props) => (
  <Svg
    width={74}
    height={12}
    viewBox="0 0 74 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M5.9147 11.9943C5.14128 12.0033 4.37374 11.8598 3.65655 11.5719C2.93936 11.284 2.28678 10.8575 1.73663 10.3171C1.18649 9.77667 0.749706 9.13314 0.451603 8.42375C0.153499 7.71436 0 6.95322 0 6.18444C0 5.41566 0.153499 4.65452 0.451603 3.94513C0.749706 3.23574 1.18649 2.59221 1.73663 2.05182C2.28678 1.51142 2.93936 1.08492 3.65655 0.797023C4.37374 0.509123 5.14128 0.365551 5.9147 0.374627V3.34958C5.15847 3.34958 4.43322 3.64816 3.89849 4.17965C3.36375 4.71114 3.06334 5.43199 3.06334 6.18363C3.06334 6.93527 3.36375 7.65612 3.89849 8.18761C4.43322 8.7191 5.15847 9.01769 5.9147 9.01769V11.9943Z"
      fill="#E40046"
    />
    <Path
      d="M46.4886 4.5292V11.9949H43.0722V4.56685H43.0665C43.0686 4.36434 42.9897 4.16929 42.8471 4.02461C42.7046 3.87993 42.51 3.79748 42.3062 3.79538C42.1025 3.79329 41.9062 3.87173 41.7607 4.01345C41.6151 4.15516 41.5322 4.34855 41.5301 4.55106V4.56685H41.5244V11.9949H38.1076V4.54013C38.1076 4.53122 38.1076 4.52272 38.1076 4.51381V4.54013H38.1019C38.1019 4.33762 38.021 4.1434 37.8769 4.0002C37.7328 3.857 37.5374 3.77656 37.3337 3.77656C37.1299 3.77656 36.9345 3.857 36.7904 4.0002C36.6464 4.1434 36.5654 4.33762 36.5654 4.54013H36.5597V11.9949H33.145V4.51584C33.1465 3.74446 33.3634 2.98864 33.7717 2.33261C34.1799 1.67659 34.7634 1.14612 35.4572 0.800347C36.1509 0.45457 36.9277 0.307064 37.7008 0.374269C38.4739 0.441473 39.2131 0.720747 39.8359 1.18097C40.4588 0.731619 41.1941 0.461426 41.9612 0.400019C42.7284 0.338612 43.4977 0.488363 44.1849 0.832849C44.872 1.17734 45.4505 1.70325 45.8568 2.35292C46.2631 3.00259 46.4815 3.75092 46.4882 4.51584C46.4886 4.51908 46.4886 4.52394 46.4886 4.5292Z"
      fill="#E40046"
    />
    <Path
      d="M65.4736 8.59847V11.9941H59.0674V0.374451H62.4841V8.59847H65.4736Z"
      fill="#E40046"
    />
    <Path
      d="M20.515 0.383133V3.77914H18.7313V11.9971H15.3149V3.77914H13.5063V0.383133H20.515Z"
      fill="#E40046"
    />
    <Path
      d="M18.7327 0.373749H15.3164V0.379417H18.7327V0.373749Z"
      fill="#E40046"
    />
    <Path
      d="M31.0163 0.631393V4.34603C31.0079 5.14848 30.7664 5.93142 30.3209 6.60069C29.8754 7.26996 29.2448 7.79705 28.5051 8.11856V11.9955H25.0887V8.09184C24.364 7.7637 23.7483 7.23709 23.3139 6.57368C22.8795 5.91027 22.6442 5.13754 22.6357 4.34603V0.631393H26.0521V4.31931H26.0574V4.3355C26.0564 4.43709 26.0758 4.53785 26.1144 4.63188C26.1531 4.72592 26.2103 4.81134 26.2826 4.88315C26.3549 4.95495 26.4408 5.0117 26.5355 5.05006C26.6301 5.08842 26.7315 5.10762 26.8337 5.10654C26.9359 5.10547 27.0369 5.08413 27.1307 5.04378C27.2245 5.00344 27.3092 4.94489 27.38 4.87158C27.4507 4.79827 27.5061 4.71166 27.5427 4.61683C27.5794 4.52199 27.5966 4.42085 27.5934 4.31931H27.6V0.631393H31.0163Z"
      fill="#E40046"
    />
    <Path
      d="M11.4105 0.374451H7.99414V11.9941H11.4105V0.374451Z"
      fill="#E40046"
    />
    <Path
      d="M73.9999 8.59847V11.9941H67.5938V0.374451H71.0105V8.59847H73.9999Z"
      fill="#E40046"
    />
    <Path
      d="M56.9402 4.51688C56.9293 3.41946 56.4831 2.37067 55.6985 1.59847C54.9139 0.826275 53.8543 0.393097 52.7501 0.393097C51.646 0.393097 50.5864 0.826275 49.8018 1.59847C49.0172 2.37067 48.5709 3.41946 48.5601 4.51688C48.5601 4.52822 48.5601 4.53915 48.5601 4.55049V12H51.9764V9.55543H53.5243V11.996H56.9406V4.53024C56.9406 4.52498 56.9406 4.52012 56.9402 4.51688ZM53.5243 6.16144H51.9764V4.56789H51.9825C51.9825 4.36538 52.0634 4.17116 52.2075 4.02796C52.3516 3.88477 52.547 3.80432 52.7507 3.80432C52.9545 3.80432 53.1499 3.88477 53.294 4.02796C53.438 4.17116 53.519 4.36538 53.519 4.56789H53.5247L53.5243 6.16144Z"
      fill="#E40046"
    />
  </Svg>
);
export default CityMallRedTextLogo;
